var findByIndex = function (arr, index) {
    return arr.find(function (item) { return item.index === index; });
};
var indexComparer = function (a, b) { return a.index - b.index; };
var expandColSpan = function (cell, row) {
    if (cell.colSpan > 1) {
        cell.parent = cell;
        for (var i = cell.colIndex + 1; i < cell.colIndex + cell.colSpan; i++) {
            row.cells[i] = {
                colIndex: i,
                parent: cell,
                rowIndex: cell.rowIndex,
                dataItem: cell.dataItem,
                dataRowIndex: cell.dataRowIndex
            };
        }
    }
};
var expandRowSpan = function (row, prevRow) {
    return prevRow.cells
        .filter(function (cell) { return cell.rowSpan && cell.rowSpan + prevRow.index > row.index; })
        .forEach(function (cell) {
        var colIndex = cell.colIndex;
        row.cells[colIndex] = {
            colIndex: colIndex,
            parent: cell,
            rowIndex: row.index,
            dataItem: cell.dataItem,
            dataRowIndex: cell.dataRowIndex
        };
    });
};
var expandAllRowSpans = function (row, allRows) {
    return allRows
        .filter(function (r) { return r.index < row.index; })
        .forEach(function (prevRow) { return expandRowSpan(row, prevRow); });
};
/**
 * @hidden
 *
 * Contains information for the currently rendered rows and cells.
 */
var NavigationModel = /** @class */ (function () {
    function NavigationModel() {
        this.rows = [];
    }
    Object.defineProperty(NavigationModel.prototype, "firstRow", {
        get: function () {
            return this.rows[0];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NavigationModel.prototype, "lastRow", {
        get: function () {
            return this.rows[this.rows.length - 1];
        },
        enumerable: true,
        configurable: true
    });
    NavigationModel.prototype.registerCell = function (cell) {
        var row = findByIndex(this.rows, cell.logicalRowIndex);
        if (!row) {
            return;
        }
        var colIndex = cell.logicalColIndex;
        var modelCell = {
            colIndex: colIndex,
            rowIndex: row.index,
            colSpan: cell.colSpan,
            rowSpan: cell.rowSpan,
            dataItem: row.dataItem,
            dataRowIndex: row.dataRowIndex,
            focusGroup: cell.focusGroup
        };
        row.cells[colIndex] = modelCell;
        if (cell.groupItem) {
            row.groupItem = cell.groupItem;
        }
        expandColSpan(modelCell, row);
    };
    NavigationModel.prototype.registerRow = function (row) {
        this.unregisterRow(row);
        var modelRow = {
            index: row.logicalRowIndex,
            dataItem: row.dataItem,
            dataRowIndex: row.dataRowIndex,
            cells: []
        };
        expandAllRowSpans(modelRow, this.rows);
        this.rows.push(modelRow);
        this.rows.sort(indexComparer);
    };
    NavigationModel.prototype.unregisterRow = function (row) {
        this.rows = this.rows.filter(function (r) { return r.index !== row.logicalRowIndex; });
    };
    NavigationModel.prototype.findRowByIndex = function (index) {
        return findByIndex(this.rows, index);
    };
    NavigationModel.prototype.findRowByPosition = function (pos) {
        var maxPos = this.rows.length - 1;
        var normalizedPos = Math.max(0, Math.min(pos, maxPos));
        return this.rows[normalizedPos];
    };
    NavigationModel.prototype.rowPosition = function (row) {
        return this.rows.indexOf(row);
    };
    return NavigationModel;
}());
export { NavigationModel };



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-angular-grid/dist/es/navigation/navigation-model.js
// module id = ../../../../@progress/kendo-angular-grid/dist/es/navigation/navigation-model.js
// module chunks = vendor